import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import CuratedItem from './CuratedItem';
import smoothscroll from 'smoothscroll-polyfill';
import './Home.css';
import MyHelmet from 'components/common/MyHelmet';

class Home extends Component {
	constructor(props) {
		super(props);
		this.listing = React.createRef();
		this.state = {
			focus: -1
		};
	}
	componentDidMount() {
		document.addEventListener('keydown', this.onKeyDown);
		smoothscroll.polyfill();
	}
	componentWillUnmount() {
		document.removeEventListener('keydown', this.onKeyDown);
	}
	onKeyDown = (e) => {
		const items = this.listing.current.querySelectorAll('.CuratedItem');
		let matchIndex = 0;
		for (const item of items) {
			const boundTop = item.getBoundingClientRect().top;
			if (boundTop >= 0) break;
			matchIndex++;
		}
		switch (e.keyCode) {
			case 37: //left
			case 38: // up
				e.preventDefault();
				this.navigateTo( matchIndex-1 );
				break;
			case 39: // right
			case 40: // down
				e.preventDefault();
				this.navigateTo( matchIndex+1 );
				break;
			default:
				break;
		}
	}
	focus = (index) => {
		this.setState({ focus: index });
	}
	blur = (index) => {
		this.setState({ focus: -1 });
	}
	navigateTo = ( index ) => {
		let safeIndex = index;
		if ( index >= this.props.items.length ) {
			safeIndex = 0;
		} else if ( index < 0 ) {
			safeIndex = this.props.items.length - 1;
		}
		const el = this.listing.current.querySelectorAll('.CuratedItem')[safeIndex];
		window.scroll({
			top: el.offsetTop-1,
			behavior: 'smooth'
		})
	}
	render() {
		const items = (this.props.items) ? this.props.items.map( (item, index) => {
			const hasProjects = (item.associatedProjects && item.associatedProjects.length > 0);
			if ( !hasProjects ) return null;

			const shouldBlur = (this.state.focus !== -1 && this.state.focus !== index);
			const classes = ['CuratedItemWrap'];
			classes.push( shouldBlur ? 'is-blur' : 'is-not-blur' );
			return (
				<div key={item.slug} 
					className={ classes.join(' ') }>
					<CuratedItem 
						{...item} 
						index={index} 
						speed={this.props.speed} 
						onMouseEnter={this.focus}
						onMouseLeave={this.blur}
					/>
				</div>
			)
		} ) : null;
		return (
			<div id="Page_Home" className="Page">
				<MyHelmet
					ogTitle="Home"
				/>{/* TODO: BAD */}

				<div className="wrap">
					<div className="CuratedItem-listing" ref={this.listing}>{items}</div>
				</div>
			</div>
		)
	}
}
Home.propTypes = {
	items: PropTypes.array.isRequired,
	speed: PropTypes.number
}
const mapStateToProps = (state) => {
	const items = get( state.fetcher, ['archives', 'curated', 'data'], [] );
	return {
		items: items,
		speed: state.config.curated_autoplay_speed || 300
	}
}
export default connect(mapStateToProps)(Home);


// WEBPACK FOOTER //
// ./src/components/Pages/Home/Home.jsx